import {
  REQUEST_APPRAISAL_PORT_HOLD_REASONS,
  RECEIVE_APPRAISAL_PORT_HOLD_REASONS,
  ERROR_APPRAISAL_PORT_HOLD_REASONS
} from "typeConstants";
import { appraisalPort as initialState } from "reducers/initialState.tsx";

const appraisalPort = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_APPRAISAL_PORT_HOLD_REASONS:
      return {
        ...state,
        isFetchingHoldReasons: true,
      };
    case RECEIVE_APPRAISAL_PORT_HOLD_REASONS:
      return {
        ...state,
        onHoldReasons: action.payload.map(r => {
          return { label: r.name, value: `${r.id}` };
        }),
        isFetchingHoldReasons: false,
      };
    case ERROR_APPRAISAL_PORT_HOLD_REASONS:
      return {
        ...state,
        isFetchingHoldReasons: false,
      };
    default:
      return state;
  }
};

export default appraisalPort;